export default "__VITE_ASSET__DSmkTB8f__";